import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Index from './component/Home';
import config from './config';
import { useEffect, useState } from 'react';
import { Route, Routes, BrowserRouter } from 'react-router-dom';
import Aboutus from './component/Aboutus';
import Howitwork from './component/Howitwork';
import PlatformInsight from './component/PlatformInsight';
import Contactus from './component/Contactus';
import Buy from './component/NewDashboard/Pages/Buy';
import Claim from './component/NewDashboard/Pages/Claim';
import PreSaleForm from './component/Forms/presaleForm';
import MultichainSwapForm from './component/Forms/multichainSwapForm';
import PreSaleSwap from './component/Forms/presaleSwapForm';
import Swap from './component/NewDashboard/Pages/Swap';
import Privacypolicy from './component/Privacypolicy';
import TermsCondition from './component/TermsCondition';
import TradingFees from './component/TradingFees';
import DashboardHome from './component/NewDashboard/Pages/DashboardHome';
import LaunchpadHome from './component/LaunchpadHome';
import WhitePaper from './component/WhitePaper';
import Promotions from './component/Promotions';
import Partnership from './component/Partnership';
import Faq from './component/Faq';
import Promote from './component/LaunchpadHome/Promote';
import Newpresale from './component/NewDashboard/Pages/Newpresale';
import Governance from './component/Governance';
import Createproposal from './component/Createproposal';

function App() {
  const [collapsed, setCollapsed] = useState(false);
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    if (width < 600) {
      setCollapsed(true);
    } else {
      setCollapsed(false);
    }
  }, [window.innerWidth]);

  // const isHome = window.location.hostname.startsWith('hub.localhost');

  // const isLaunchpad = window.location.hostname.startsWith(
  //   'launchpad.localhost'
  // );

  // const isTrade = window.location.hostname.startsWith('trade.localhost');

  // const isSwap = window.location.hostname.startsWith('swap.localhost');

  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path={`${config.baseUrl}`} element={<Index />} />
          <Route
            path={`${config.baseUrl}launchpad`}
            element={<LaunchpadHome />}
          />
          <Route path={`${config.baseUrl}about`} element={<Aboutus />} />
          <Route path={`${config.baseUrl}howitwork`} element={<Howitwork />} />
          <Route
            path={`${config.baseUrl}platformInsight`}
            element={<PlatformInsight />}
          />
          <Route
            path={`${config.baseUrl}privacypolicy`}
            element={<Privacypolicy />}
          />
          <Route
            path={`${config.baseUrl}termscondition`}
            element={<TermsCondition />}
          />
          <Route
            path={`${config.baseUrl}whitepaper`}
            element={<WhitePaper />}
          />
          <Route path={`${config.baseUrl}promos`} element={<Promotions />} />
          <Route
            path={`${config.baseUrl}partnership`}
            element={<Partnership />}
          />
          <Route path={`${config.baseUrl}contact`} element={<Contactus />} />
          <Route path={`${config.baseUrl}faq`} element={<Faq />} />
          <Route
            path={`${config.baseUrl}tradingfees`}
            element={<TradingFees />}
          />
          <Route
            path={`${config.baseUrl}:id/swap/:token_name_USDT`}
            element={<Swap />}
          />
          <Route
            path={`${config.baseUrl}:id/buy/:token_name`}
            element={<Buy />}
          />
          <Route
            path={`${config.baseUrl}:id/claim/:token_name`}
            element={<Claim />}
          />
          <Route
            path={`${config.baseUrl}presaleForm`}
            element={<PreSaleForm />}
          />
          <Route
            path={`${config.baseUrl}multichainSwapForm`}
            element={<MultichainSwapForm />}
          />
          <Route
            path={`${config.baseUrl}:id/presaleSwap`}
            element={<PreSaleSwap />}
          />
          <Route
            path={`${config.baseUrl}dashboard/:walletAddress/home`}
            element={<DashboardHome />}
          />
          <Route path={`${config.baseUrl}promote`} element={<Promote />} />

          {/* --------------- */}
          <Route path={`${config.baseUrl}governance`} element={<Governance />} />
           <Route path={`${config.baseUrl}createproposal`} element={<Createproposal />} />
          <Route path={`${config.baseUrl}newpresale`} element={<Newpresale />} />

          {/* <Route path={`${config.baseUrl}governance`} element={<Governance />} />
          <Route path={`${config.baseUrl}createproposal`} element={<Createproposal />} />
          <Route
            path={`${config.baseUrl}dashboard2`}
            element={<DashboardHome2 />}
          />
          <Route
            path={`${config.baseUrl}token`}
            element={<Token />}
          /> */}

        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
